import cn from 'classnames'
import IPath from 'interfaces/IPath'
import { FC, HTMLAttributes, useMemo } from 'react'

import Head from 'next/head'
import Link from 'next/link'
import { useRouter } from 'next/router'

import styles from './Breadcrumbs.module.scss'

interface IBreadcrumbsProps {
  path: IPath[]
  white?: boolean
  black?: boolean
  className?: string
  host?: string
}
const Bredcrumbs: FC<IBreadcrumbsProps & HTMLAttributes<HTMLDivElement>> = ({
  path,
  white,
  black,
  className,
  host,
}) => {
  const { locale, defaultLocale } = useRouter()
  const localePrefix = locale !== defaultLocale ? `/${locale}` : ''

  const schemaScript = useMemo(() => {
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: path.map((p, index) => {
        return {
          '@type': 'ListItem',
          position: index + 1,
          item: {
            '@id': `https://${host}${localePrefix}${p.link}`,
            name: p.title,
          },
        }
      }),
    }
  }, [path, host, localePrefix])

  return (
    <>
      {host && (
        <Head>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaScript) }}
          />
        </Head>
      )}
      <div
        className={cn(styles.breadcrumbs, className, {
          [styles.white]: white,
          [styles.black]: black,
        })}
      >
        <ol itemScope itemType="https://schema.org/BreadcrumbList">
          {path.map((p, index) => {
            const isLast = index === path.length - 1
            return (
              <li
                key={index}
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                {isLast ? (
                  <span itemProp="item" className={styles.breadcrumb}>
                    <span itemProp="name">{`${p.title} `}</span>
                  </span>
                ) : (
                  <Link itemProp="item" className={styles.breadcrumb} href={p.link}>
                    <span itemProp="name">{`${p.title} `}</span>
                  </Link>
                )}
                <meta itemProp="position" content={(index + 1).toString()} />
              </li>
            )
          })}
        </ol>
      </div>
    </>
  )
}

export default Bredcrumbs
